export enum MappingJobStepStatus {
  PENDING = 'PENDING',
  RUNNING = 'RUNNING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export type MappingJobStep = {
  /**
   * The unique identifier for the mapping job step.
   */
  id: string

  /**
   * The identifier of the mapping job this step belongs to.
   */
  mappingJobId: string

  /**
   * The name of the mapping job step.
   */
  name: string

  /**
   * The start timestamp of the mapping job step.
   */
  startTime?: Date

  /**
   * The end timestamp of the mapping job step.
   */
  endTime?: Date

  /**
   * The status of the mapping job step.
   * @default PENDING
   */
  status: MappingJobStepStatus

  /**
   * The time the entity was created. This attribute is automatically
   * set by the dynamodb-onetable library.
   */
  created: Date

  /**
   * The user id of the user who created this entity.
   */
  createdBy: string

  /**
   * The last time this entity was modified. This attribute is automatically
   * set by the dynamodb-onetable library.
   */
  updated: Date

  /**
   * The user id of the user who last updated this entity.
   */
  updatedBy: string
}

export type MappingJobStepProgress = {
  mappingJobStepId: string
  status: MappingJobStepStatus
  startTime?: Date
  endTime?: Date
}

// This is a temporary measure to allow updating steps by name.
// TODO: Remove this when we have implemented our own state machine.
export type MappingJobStepProgressByName = {
  mappingJobId: string
  name: string
  status: MappingJobStepStatus
  startTime?: Date
  endTime?: Date
}

export type CreateMappingJobStepInput = Omit<
  MappingJobStep,
  'id' | 'created' | 'updated' | 'createdBy' | 'updatedBy'
>

export type GetMappingJobStepInput = {
  mappingJobStepId: string
}

export type GetMappingJobStepsInput = {
  mappingJobId: string
}

export type GetMappingJobStepByNameInput = {
  mappingJobId: string
  name: string
}

// This is a temporary measure to allow updating steps by name.
// TODO: Remove this when we have implemented our own state machine.
export type UpdateMappingJobStepByNameInput = Omit<
  MappingJobStep,
  'id' | 'created' | 'updated' | 'createdBy' | 'updatedBy'
>

export type DeleteMappingJobStepInput = {
  mappingJobStepId: string
}
